import React from 'react';
import RoomContentWrapper, {
  RoomContentWrapperProps,
} from './RoomContentWrapper';
import ImageTracker, { ImageTrackerProps } from '../Tracking/ImageTracker';

type PickedContentWrapperProps = Omit<RoomContentWrapperProps, 'width'>;
type PickedImageTrackerProps = Omit<ImageTrackerProps, 'width'>;

export interface RoomImageContentProps
  extends PickedContentWrapperProps,
    PickedImageTrackerProps {
  disableContentName?: boolean;
  imageWidth: number;
}

const RoomImageContent: React.FC<RoomImageContentProps> = (
  props: RoomImageContentProps
): JSX.Element => {
  const {
    cover,
    disableContentName = false,
    imageWidth,
    name,
    rounded,
    ...imageTrackerProps
  } = props;

  let fullScreenTitle = '';
  if (!disableContentName && name) {
    fullScreenTitle = name;
  }

  return (
    <RoomContentWrapper cover={cover} disableMinHeight rounded={rounded}>
      <ImageTracker
        {...imageTrackerProps}
        name={name}
        title={fullScreenTitle}
        width={imageWidth}
      />
    </RoomContentWrapper>
  );
};

export default RoomImageContent;
